import { Dialog } from 'primereact/dialog'
import React, { useRef, useState } from 'react'
import { Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { InputNumber } from 'primereact/inputnumber'
import SharedInputText from '../components/Shared/SharedInputText'
import SharedButton from '../components/Shared/SharedButton'
import { Toast } from 'primereact/toast'
import supergitHIS from '../api/supergitHIS'
import toast from 'react-hot-toast'
import validSupergitHIS from '../api/validSupergitHIS'

export default function GalleryRevokeUpdate(props) {
  const { visible, setVisible, revokeData, setRevokeData, fetchAgain } = props
  const { t } = useTranslation()
  const formikRef = useRef(null)
  const toastRef = useRef(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [editingRow, setEditingRow] = useState(null)

  const formatDate = dateString => {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toLocaleDateString()
  }

  const formatCurrency = amount => {
    if (amount === undefined || amount === null) return '0.00'
    return parseFloat(amount).toFixed(2)
  }

  const initialValues = {
    CustomerName: revokeData?.revoke?.CustomerName || '',
    CustomerID: revokeData?.revoke?.CustomerID || '',
    CustomerOrderID: revokeData?.revoke?.CustomerOrderID || '',
    CustomerOrderSerial: revokeData?.revoke?.CustomerOrderSerial || '',
    RevokeDate: revokeData?.revoke?.RevokeDate || '',
    GalleryName: revokeData?.revoke?.GalleryName || '',
    GalleryAddress: revokeData?.revoke?.GalleryAddress || '',
    Phone:
      revokeData?.revoke?.Mobile ||
      revokeData?.revoke?.Phones ||
      revokeData?.revoke?.Phone2 ||
      '',
    SalesPersonName: revokeData?.revoke?.SalesPersonName || '',
    EmployeeName: revokeData?.revoke?.EmployeeName || '',
    RevokeAmountBeforeDiscount:
      revokeData?.revoke?.RevokeAmountBeforeDiscount || 0,
    Discount: revokeData?.revoke?.Discount || 0,
    RevokeAmount: revokeData?.revoke?.RevokeAmount || 0,
    InvoiceId: revokeData?.revoke?.InvoiceId || '',
    LocalSerial: revokeData?.revoke?.LocalSerial || '',
    Paid: revokeData?.revoke?.Paid || false,
    RevokePaymentNo: revokeData?.revoke?.RevokePaymentNo || '',
    CurrencyName: revokeData?.revoke?.CurrencyName || '',
    TransYear: revokeData?.revoke?.TransYear || '',
    TransType: revokeData?.revoke?.TransType || '',
    SearchSerial: revokeData?.revoke?.SearchSerial || '',
    ReceiptNo: revokeData?.revoke?.ReceiptNo || '',
    Comments: revokeData?.revoke?.Comments || '',
    items: revokeData?.details ? [...revokeData.details] : []
  }

  const handleSubmit = async values => {
    setIsSubmitting(true)
    try {
      const { items, ...rest } = values
      const payload = {
        details: [...items],
        revoke: {
          ...revokeData,
          ...rest
        }
      }
      const response = await validSupergitHIS.get(
        `invoices/customerRevokes/edit/${revokeData?.revoke?.CustomerRevokeID}`,
        payload
      )
      setRevokeData(null)
      setVisible(false)
      fetchAgain()
      toast.success(response?.data?.message)
    } catch (error) {
      console.error(error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <Toast ref={toastRef} />
      <Dialog
        header={t('Edit Revoke')}
        visible={visible}
        onHide={() => setVisible(false)}
        pt={{
          root: { className: 'w-full lg:w-10/12 mx-4 overflow-auto' },
          header: { className: '!p-2 !bg-darkBg !text-white' },
          content: { className: '!p-3' },
          closeButton: {
            className: 'hover:!bg-black/20 !outline-none !shadow-none'
          },
          closeButtonIcon: { className: '!text-white' }
        }}
      >
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          onSubmit={handleSubmit}
        >
          {formik => (
            <>
              <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 w-full mb-6'>
                <SharedInputText
                  label={t('Customer Name')}
                  name='CustomerName'
                  value={formik.values.CustomerName}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />

                <SharedInputText
                  label={t('Order Serial')}
                  name='CustomerOrderSerial'
                  value={formik.values.CustomerOrderSerial}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Revoke Date')}
                  name='RevokeDate'
                  value={formatDate(formik.values.RevokeDate)}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Gallery')}
                  name='GalleryName'
                  value={formik.values.GalleryName}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Gallery Address')}
                  name='GalleryAddress'
                  value={formik.values.GalleryAddress}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Phone')}
                  name='Phone'
                  value={formik.values.Phone}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Sales Person')}
                  name='SalesPersonName'
                  value={formik.values.SalesPersonName}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Cashier')}
                  name='EmployeeName'
                  value={formik.values.EmployeeName}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Total Revoke Amount')}
                  name='RevokeAmountBeforeDiscount'
                  value={`${formatCurrency(
                    formik.values.RevokeAmountBeforeDiscount
                  )} ${formik.values.CurrencyName || 'SAR'}`}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Discount')}
                  name='Discount'
                  value={`${formatCurrency(formik.values.Discount)} ${formik.values.CurrencyName || 'SAR'
                    }`}
                  onChange={e => {
                    const value =
                      parseFloat(e.target.value.replace(/[^0-9.]/g, '')) || 0
                    formik.setFieldValue('Discount', value)
                    formik.setFieldValue(
                      'RevokeAmount',
                      formik.values.RevokeAmountBeforeDiscount - value
                    )
                  }}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Net Revoke Amount')}
                  name='RevokeAmount'
                  value={`${formatCurrency(formik.values.RevokeAmount)} ${formik.values.CurrencyName || 'SAR'
                    }`}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Invoice ID')}
                  name='InvoiceId'
                  value={formik.values.InvoiceId}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Local Serial')}
                  name='LocalSerial'
                  value={formik.values.LocalSerial}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Status')}
                  name='Paid'
                  value={formik.values.Paid ? 'Paid' : 'Unpaid'}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Revoke Payment No')}
                  name='RevokePaymentNo'
                  value={formik.values.RevokePaymentNo}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Currency')}
                  name='CurrencyName'
                  value={formik.values.CurrencyName}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Transaction Year')}
                  name='TransYear'
                  value={formik.values.TransYear}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Transaction Type')}
                  name='TransType'
                  value={formik.values.TransType}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Search Serial')}
                  name='SearchSerial'
                  value={formik.values.SearchSerial}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Receipt No')}
                  name='ReceiptNo'
                  value={formik.values.ReceiptNo}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Comments')}
                  name='Comments'
                  value={formik.values.Comments}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
              </div>

              <div className='mt-6'>
                <h3 className='text-lg font-semibold mb-4'>
                  {t('Revoke Items')}
                </h3>

                <div className='overflow-x-auto'>
                  <table className='min-w-full divide-y divide-gray-200'>
                    <thead className='bg-gray-50'>
                      <tr>
                        <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                          {t('Code')}
                        </th>
                        <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                          {t('Description')}
                        </th>
                        <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                          {t('Qty')}
                        </th>
                        <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                          {t('Unit Price')}
                        </th>
                        <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                          {t('Total Price')}
                        </th>
                        <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                          {t('Retail Price')}
                        </th>
                        <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                          {t('Coast price')}
                        </th>
                      </tr>
                    </thead>
                    <tbody className='bg-white divide-y divide-gray-200'>
                      {formik.values.items.map((item, index) => (
                        <tr key={index}>
                          <td className='px-6 py-4 whitespace-nowrap'>
                            <SharedInputText
                              name={`items[${index}].ProductCode`}
                              value={item.ProductCode}
                              className='!p-1.5 !m-0 w-full'
                              onChange={e =>
                                formik.setFieldValue(
                                  `items[${index}].ProductCode`,
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td className='px-6 py-4 whitespace-nowrap'>
                            <SharedInputText
                              name={`items[${index}].Description`}
                              value={
                                item.Description || item.PrintInvoiceDescription
                              }
                              className='!p-1.5 !m-0 w-full'
                              onChange={e =>
                                formik.setFieldValue(
                                  `items[${index}].Description`,
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td className='px-6 py-4 whitespace-nowrap'>
                            <InputNumber
                              value={item.Quantity}
                              name={`items[${index}].Quantity`}
                              mode='decimal'
                              min={1}
                              className='w-full'
                              inputClassName='!p-1.5 !m-0 w-full'
                              onValueChange={e =>
                                formik.setFieldValue(
                                  `items[${index}].Quantity`,
                                  e.value || 0
                                )
                              }
                            />
                          </td>
                          <td className='px-6 py-4 whitespace-nowrap'>
                            <InputNumber
                              value={item.UnitPrice || item.UPrice}
                              name={`items[${index}].UnitPrice`}
                              className='w-full'
                              inputClassName='!p-1.5 !m-0 w-full'
                              onValueChange={e =>
                                formik.setFieldValue(
                                  `items[${index}].UnitPrice`,
                                  e.value || 0
                                )
                              }
                            />
                          </td>
                          <td className='px-6 py-4 whitespace-nowrap'>
                            <InputNumber
                              value={item.TotalPrice || item.TPrice}
                              name={`items[${index}].TotalPrice`}
                              className='w-full'
                              inputClassName='!p-1.5 !m-0 w-full'
                              onValueChange={e =>
                                formik.setFieldValue(
                                  `items[${index}].TotalPrice`,
                                  e.value || 0
                                )
                              }
                            />
                          </td>

                          <td className='px-6 py-4 whitespace-nowrap'>
                            <InputNumber
                              value={item.RetailPrice || item.RetailPrice}
                              name={`items[${index}].RetailPrice`}
                              className='w-full'
                              inputClassName='!p-1.5 !m-0 w-full'
                              onValueChange={e =>
                                formik.setFieldValue(
                                  `items[${index}].RetailPrice`,
                                  e.value || 0
                                )
                              }
                            />
                          </td>
                          <td className='px-6 py-4 whitespace-nowrap'>
                            <InputNumber
                              value={item.CostPrice}
                              name={`items[${index}].CostPrice`}
                              className='w-full'
                              inputClassName='!p-1.5 !m-0 w-full'
                              onValueChange={e =>
                                formik.setFieldValue(
                                  `items[${index}].CostPrice`,
                                  e.value || 0
                                )
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className='flex justify-end gap-6 mt-6'>
                <SharedButton
                  icon='pi pi-times'
                  label={t('Cancel')}
                  className='cancel-btn'
                  onClick={() => {
                    setVisible(false)
                    setRevokeData(null)
                    formik.resetForm()
                  }}
                />
                <SharedButton
                  icon='pi pi-check'
                  label={t('Save')}
                  className='submit-btn'
                  onClick={formik.handleSubmit}
                  disabled={isSubmitting}
                />
              </div>
            </>
          )}
        </Formik>
      </Dialog>
    </>
  )
}
